<p-dialog
[closeAriaLabel]="'iaa.general.closePane'| translate" 
[(visible)]="isOpen"
[dismissableMask]="true"
[modal]="true"
[header]="'iaa.app.results.unauthorizedDialog.licensesNotDisplayed' | translate"
maskStyleClass="dialog-mask"
(onHide)="handleClose()"
[ngClass]="{'dialog':true,'en': currentLanguage === 'en'}">
<div class="rtl-table-wrapper" dir="rtl">
  <p-table 
    [scrollable]="true"
    [selectionMode]="'single'"
    [styleClass]="'hover-text rtl-table'"
    [value]="unauthorizedLicenses"
    scrollHeight="400px"
    [ngClass]="{'en': currentLanguage === 'en'}">
    <ng-template pTemplate="header">
      <tr class="grid-row">
        <th>{{'iaa.general.license' | translate}}</th>
        <th>{{'iaa.general.expedition' | translate}}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-entity>
      <tr class="grid-row">
        <td>
          <bdi>{{ entity.license }}</bdi>
        </td>
        <td>
          <bdi>{{ entity.expedition }}</bdi>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
<div [ngClass]="{'dialog-footer':true,'en': currentLanguage === 'en'}">
    <p-button
      [id]="'closeDialog'"
      (click)="handleClose()"
      [rounded]="true"
      [styleClass]="'prime-button'"
      [label]="'iaa.general.ok' | translate"
    />
  </div>
</p-dialog>